import { createContext, ReactNode, useContext } from 'react';

import { DynamicConfig } from ':support/config';

const DynamicConfigContext = createContext<DynamicConfig | null>(null);

type DynamicConfigProviderProps = {
  children: ReactNode;
  config: DynamicConfig;
};

export function DynamicConfigProvider({ children, config }: DynamicConfigProviderProps) {
  return <DynamicConfigContext.Provider value={config}>{children}</DynamicConfigContext.Provider>;
}

export function useDynamicConfig(): DynamicConfig {
  const config = useContext(DynamicConfigContext);

  if (!config) {
    throw new Error('useDynamicConfig must be used within a DynamicConfigProvider');
  }

  return config;
}
